import React from 'react';
import Lottie from 'components/lottie/lottie.component';

import loadAnimation from 'assets/load/energy.min.json';

import { Container } from './loader.styles';

export const Loader = () => (
  <Container>
    <Lottie style={{ height: 150 }} animationData={loadAnimation} />
  </Container>
);
